<template>
<div class="chapter">
<div class="inner_page">
<p class="nonindent3"><a id="page1"></a><strong>Introducing this exciting rerelease of <em>USA TODAY</em> bestselling author Lynne Graham’s longer-length Harlequin Presents title, <em>Emerald Mistress</em>, available digitally for the first time!</strong></p>
<p class="nonindent2">When Harriet Carmichael’s world comes crashing down, she’s determined to count her blessings. Forget London, her failing career and her unfaithful fiancé—an unexpected legacy of a cottage and stables in an Irish village beckons!</p>
<p class="nonindent2">But her fresh start is soon threatened by Rafael Cavaliere: her new neighbour <em>and</em> the very man who cost Harriet her job! With her heart so recently burned she’s reluctant to become another notch on his bedpost, but when passion ensnares them both, deep secrets are revealed—ones that could change their lives forever.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bcc.vue?9d342b4c